import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import './Parcours.css';

const ParcoursBlocks = [
	{
		id: 1,
		type: 'content',
		theme: 'red',
		title: 'Parcours IT Sales',
		description:
			'Formez-vous à la vente de solutions technologiques et développez des compétences clés en prospection, négociation et closing.',
		items: [
			'Comprendre les besoins des entreprises',
			'Proposer des solutions IT à forte valeur',
			'Développer vos compétences en prospection',
			'Renforcer vos techniques de négociation et de closing',
		],
		buttonLabel: 'Découvrir le parcours',
		background: '#717272',
		niveau: 'niveau1',
		link: '/formations/it-sales',
	},
	{
		id: 2,
		type: 'image',
		image: '/assets/images/sales-it/PAGE PARCOURSIT SALES.png',
		alt: 'Parcours IT Sales',
	},
	{
		id: 3,
		type: 'image',
		image: '/assets/images/sales-it/IT-SALES-NIVEAU-2.png',
		alt: 'Parcours Intelligence Artificielle',
	},
	{
		id: 4,
		type: 'content',
		theme: 'blue',
		title: 'Parcours Intelligence Artificielle',
		description:
			'Apprenez à concevoir des agents IA capables d’automatiser des tâches et d’améliorer la performance des entreprises.',
		items: [
			'Concevoir des agents IA',
			'Automatiser des tâches métier',
			'Maîtriser les outils modernes de l’intelligence artificielle',
			'Développer des solutions concrètes pour l’entreprise',
		],
		buttonLabel: 'Explorer le parcours',
		background: '#53b5e6',
		niveau: 'niveau2',
		link: '/formations/agentic-ia',
	},
];
export default function Parcours() {
	return (
		<section className='parcours'>
			<div className='parcours__container'>
				<div className='parcours__header'>
					<span className='parcours__eyebrow'>NOS PARCOURS</span>
					<h2 id='bas' className='parcours__section-title'>
						Choisissez votre parcours
					</h2>
					<p className='parcours__section-description'>
						Découvrez deux parcours professionnalisants conçus pour répondre aux
						besoins du marché et développer des compétences concrètes.
					</p>
				</div>

				<div className='parcours__grid'>
					{ParcoursBlocks.map((block) =>
						block.type === 'content' ? (
							<article
								key={block.id}
								className={`parcours__panel parcours__panel--content parcours__panel--${block.theme}`}
								style={{ backgroundColor: block.background }}>
								<div className='parcours__overlay' />

								<div className='parcours__content'>
									<h3 className='parcours__title'>{block.title}</h3>
									<p className='parcours__description'>{block.description}</p>

									<ul className='parcours__list'>
										{block.items.map((item, index) => (
											<li key={index} className='parcours__list-item'>
												<span className='parcours__list-icon-wrap'>
													<Check
														className='parcours__list-icon'
														strokeWidth={2.5}
													/>
												</span>
												<span className='parcours__list-text'>{item}</span>
											</li>
										))}
									</ul>

									<Link
										to={block.link}
										state={{
											niveau: block.niveau,
											programTitle: block.title,
										}}
										className='parcours__button'>
										<span className='parcours__button-fill' />
										<span className='parcours__button-text'>
											{block.buttonLabel}
										</span>
									</Link>
								</div>
							</article>
						) : (
							<article
								key={block.id}
								className='parcours__panel parcours__panel--image'>
								<img
									className='parcours__image'
									src={block.image}
									alt={block.alt}
								/>
							</article>
						),
					)}
				</div>
			</div>
		</section>
	);
}
